import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询日志
export function querysyslog (params, data) {
  params.token = getToken()
  return request({
    url: '/querysyslog',
    method: 'post',
    params,
    data
  })
}
// 查询登录日志
export function queryloginlog (data) {
  return request({
    url: '/queryloginlog',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新增导出日志
export function addexportlog (data) {
  return request({
    url: '/addexportlog',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询导出日志（分页）
export function queryexportlog (data) {
  return request({
    url: '/queryexportlog',
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      from: data.from,
      to: data.to
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/log.js